export default "__VITE_ASSET__7dpsm70g__"